import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logoAzul from "@/assets/logo-azul.webp";
import { TopBanner } from "@/components/TopBanner";

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogoClick = () => {
    if (isHomePage) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <div className="sticky top-0 z-50">
      <TopBanner />
      <header
        className={`transition-all duration-300 ${
          isScrolled
            ? "bg-background/95 backdrop-blur-md shadow-sm border-b border-border"
            : "bg-background/80 backdrop-blur-sm border-b border-border/30"
        }`}
      >
        <nav className="container flex items-center justify-between h-16 lg:h-20">
          <Link to="/" onClick={handleLogoClick} className="flex items-center">
            <img
              src={logoAzul}
              alt="Aceena"
              width={120}
              height={32}
              className="h-7 lg:h-9 w-auto transition-all duration-300"
            />
          </Link>

          <Link
            to="/blog"
            className="transition-colors text-sm font-medium text-muted-foreground hover:text-foreground"
          >
            Blog
          </Link>
        </nav>
      </header>
    </div>
  );
};
